// Action types
export const SET_DASHBOARD_NEEDS_REFRESH = "SET_DASHBOARD_NEEDS_REFRESH";

// Action creator
export const setDashboardNeedsRefresh = (needsRefresh) => ({
  type: SET_DASHBOARD_NEEDS_REFRESH,
  payload: needsRefresh,
});
